module.exports = __webpack_public_path__ + "img/error.48135b1f.svg";